module.exports = __webpack_public_path__ + "img/studio-agency.2091af11.png";